import {Component, ElementRef, ViewChild} from '@angular/core';
import {
  AlertController,
  Events,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams
} from 'ionic-angular';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {InsuranceProvider} from "../../providers/insurance/insurance";
import {WheelSelector} from "@ionic-native/wheel-selector";
import {AppPopupEvaluationPage} from "../app-popup-evaluation/app-popup-evaluation";
import {AppPopupEvaluationMailSentPage} from "../app-popup-evaluation-mail-sent/app-popup-evaluation-mail-sent";
import {LocalStorageWrapper} from "../../providers/local-storage-wrapper/local-storage-wrapper";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";

/**
 * Generated class for the AppPaymentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-payment',
  templateUrl: 'app-payment.html',
})
export class AppPaymentPage {

  loader: any;
  step: number = 1;
  companies: Array<any>;
  selectedCompany: any;
  selectedCompanyObject: any;
  response: number = 0;

  deletionMode: boolean = false;
  chooseProvider: boolean = false;

  evaluationAmount:number;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider, public api: ApiProvider, public userState: UserStateProvider, public iab: InAppBrowser, public events: Events, public loaderCtrl: LoadingController, public apiAuth: ApiAuthProvider, public insurance: InsuranceProvider, public selector: WheelSelector, public modalCtrl: ModalController, public localStorage: LocalStorageWrapper, public loadingCtrl: LoadingController) {

    if(this.navParams.get('payAndDelete') === 1) {
      this.deletionMode = true;
    }

    this.events.subscribe('app:payment-received', () => {
      console.log('payment received event received');
      this.navCtrl.pop();
      this.userState.user.locked = false;
      this.loader.dismiss();

      if(this.localStorage.getItem('payment_survey_response') == '1') {
        this.api.callPost('/users/' + this.userState.user.id + "/evaluation", {}).subscribe(() => {
          console.log('evaluation mail sent');
        });
      }

      if(this.deletionMode) {
        const alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent('Payment for deletion received title'),
          subTitle: this.contentTranslation.translateContent('Payment for deletion received body'),
          buttons: [
            {
              text: 'OK',
            },
            {
              text: '×',
              cssClass: 'close-button'
            }

          ],
          cssClass: 'ip-alert ip-with-close'
        });
        alert.present();

        alert.onDidDismiss(() => {
          var loading = this.loadingCtrl.create({})
          loading.present();

          this.apiAuth.delete().then(() => {
            this.apiAuth.logout().then(() => {
              this.navCtrl.push(IntroWelcomePage)
            });
            loading.dismissAll();
          }).catch(() => {
            loading.dismissAll();
          })
        })
        return ;
      }

      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Payment received title'),
        subTitle: this.contentTranslation.translateContent('Payment received body'),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();

      this.apiAuth.tryToRefreshSession().then();
    })
    this.events.subscribe('app:payment-failed', () => {
      console.log('payment failed event received');
      this.loader.dismiss();
    });
    this.events.subscribe('app:resumed', () => {
      console.log('app resumed');
      this.loader.dismiss();
    });

    this.insurance.getCompanies().then(data => {
      this.companies = data;
      this.companies.sort((a,b) => {
        return a.position > b.position?1:-1;
      })

      this.companies.forEach(company => {
        if(company.evaluationAmount && this.userState.user.insurance && company.name == this.userState.user.insurance.type) {
          this.evaluationAmount = company.evaluationAmount;
        }
      })
    });
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppPaymentPage');

  }
  ionViewWillLoad() {
    document.body.classList.add('hide-tabs');
  }
  ionViewWillLeave() {
    document.body.classList.remove('hide-tabs');
  }

  evaluationInfoClick(e) {
    if(e.target.tagName == 'STRONG' && e.target.className.indexOf('modal-evaluation-info')>-1) {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Evaluation info modal title'),
        subTitle: this.contentTranslation.translateContent('Evaluation info modal body'),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();
    }
  }


  buy(method: string) {
    var me = this;

    this.localStorage.setItem('payment_survey_response', this.response.toString());

    this.loader = this.loaderCtrl.create({
    });
    this.loader.present();

    this.api.callPost('/users/'+this.userState.user.id+"/paymentRequest", {method: method, evaluation: this.response, payAndDelete: this.deletionMode}).subscribe((resp: any) => {
      if(resp.url) {
        let browser = me.iab.create(resp.url, "_system");

        // setTimeout(() => {
        //   this.events.publish('app:payment-received');
        // }, 2000);
        //
        return ;
      }
    })


  }

  showTerms(prefix) {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Registration Form Modal '+prefix+' title'),
      subTitle: this.contentTranslation.translateContent('Registration Form Modal '+prefix+' text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  nextStep() {
    this.step = 2;
  }
  chooseCompanyPopup() {

    let companiesSimple = this.companies.map((row) => {
      return {description: row.name, name: row.name, free: row.free, payoutAmount: row.payoutAmount, infoText: row.infoText}
    });;

    console.log(companiesSimple);


    this.selector.show({
      title: this.contentTranslation.translateContent('Select company'),
      positiveButtonText: this.contentTranslation.translateContent('Wheel OK'),
      negativeButtonText: this.contentTranslation.translateContent('Wheel Cancel'),
      items: [
        companiesSimple
      ],
    }).then(
        result => {
          this.companyChanged(companiesSimple[result[0].index]);
          this.selectedCompany = companiesSimple[result[0].index].name;
        },
        err => console.log('Error: ', err)
    );
  }

  showInfo() {
    let modal = this.modalCtrl.create(AppPopupEvaluationMailSentPage, {}, {cssClass: 'modal-alert ip-alert ip-with-close ip-training-notifications-popup app-modal-popup'});
    modal.present().then();
  }

  companyChanged(company) {
    this.selectedCompanyObject = company;
    console.log(this);
  }

  choosePaymentMethod() {
    this.chooseProvider = true;
  }


}



// WEBPACK FOOTER //
// ./src/pages/app-payment/app-payment.ts